/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';

const DEFAULT_GROUP_LABEL = 'default';

export default function Tab({tab, Field, mode,defaultImage}) {
  if (!tab) {
    return null;
  }

  const Group = mode !== 'print' ? DefaultGroup : PrintGroup;

  return (
    <div className="tabDiv">
      {
        tab.groups.map((group, i) => (
          <div key={i}>
            <GroupLabel label={group.label} />
            <Group fields={group.fields} mode={mode} Field={Field} defaultImage={defaultImage} />
          </div>
        ))
      }
    </div>
  );
}

const GroupLabel = ({label}) => {
  if (label === DEFAULT_GROUP_LABEL) {
    return null;
  }

  return <h2 className="table-header label">{label}</h2>;
};

const DefaultGroup = ({fields, mode, Field, defaultImage}) => {
  return (
    <table className="mdtable">
      <tbody>
        {
          fields.map((field, j) => {
            const shaded = j % 2 !== 0;
            return (
              <tr className={shaded ? 'mdrow shaded' : 'mdrow'} key={j}>
                <td className="mdvalue">
                  <Field field={field} mode={mode} shaded={shaded} defaultImage={defaultImage}/>
                </td>
              </tr>
            );
          })
        }
      </tbody>
    </table>
  );
};

const PrintGroup = ({fields, mode, Field}) => {
  return (
    <Fragment>
      {
        fields.map((field, j) => (
          <Field key={j} field={field} mode={mode} />
        ))
      }
    </Fragment>
  );
};